/**
 * It's a generated file, preferable to extend this in external file
 */
import {TransportTypeName} from 'common/enums';
import * as yup from 'common/yup';
import {TransportType} from 'types/TransportType';
import {AbstractTransport, transportTypeSchema} from '../Abstract/AbstractTransport';
import {transportTypeNameSchema} from '../TransportTypeName';
import {OneDriveServer} from './OneDriveServer';

export const OneDriveTransport = AbstractTransport.shape({
   typeName: transportTypeNameSchema.default(TransportTypeName.ONEDRIVE),
   transportType: transportTypeSchema.default(TransportType.enum.ONEDRIVE),
   server: OneDriveServer,
});
export type IOneDriveTransport = yup.InferType<typeof OneDriveTransport>;
